package com.nonopn.skywatcher.common.api

import kotlinx.serialization.Serializable

/**
 * Body of POST /api/checkout/login (no authentication). Exactly these three fields: any missing or extra field
 * is refused by the backend (400 InvalidBody). `sessionId` is the `session_id` parameter of the success URL.
 */
@Serializable
data class CheckoutLoginRequest(
    val app: String,
    val code: String,
    val sessionId: String
)

/** Answer of POST /api/checkout/login: the same bearer token as a regular login. */
@Serializable
data class CheckoutLoginAnswer(
    val token: String
)
